const LINK_EVENTS = [
  ['https://wa.me/', 'pantanal:whatsapp_click'],
  ['tel:', 'pantanal:phone_click'],
  ['mailto:', 'pantanal:email_click'],
];

document.addEventListener(
  'click',
  (event) => {
    const link = event.target instanceof Element ? event.target.closest('a[href]') : null;
    if (!link) return;
    const match = LINK_EVENTS.find(([prefix]) => link.href.startsWith(prefix));
    if (!match) return;
    window.Shopify?.analytics?.publish?.(match[1], {
      label: link.textContent.trim().replace(/\s+/g, ' ').slice(0, 80),
      section: link.closest('.shopify-section')?.id ?? '',
      page: location.pathname,
    });
  },
  { capture: true }
);
